/**
 * Matter Types — directApiClient queries (LF-3214)
 */

'use client';

import { ActionResult } from '@/lib/types/actions';
import { MatterType } from './types';
import { directApiClient } from '@/lib/api/direct-client';

export async function getMatterTypesAction(): Promise<
  ActionResult<MatterType[]>
> {
  try {
    const response = await directApiClient.get<MatterType[]>('/matter-types');
    return { success: true, data: response };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to fetch matter types'
    };
  }
}
